import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const treeMapValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'color', type: 'number', required: false }
  ],
  businessRules: [
    {
      name: 'treemap-sufficient-data',
      validator: data => data.length > 1,
      message: 'TreeMap requires more than 1 data point',
      suggestion: 'Provide at least 2 data points for proper treemap visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
